import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCalculateChargesRequestSchema,
  TCalculateChargesResponseSchema,
} from "./calculateCharges.schema";

export const calculateCharges = (axios: IAxiosInstance) => {
  return async (data: TCalculateChargesRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCalculateChargesResponseSchema>
    >(`/api/charges-and-fees/calculate`, data);

    return response.data;
  };
};
